import _ from "lodash";
import { cache } from "lib/apolloClient";
import client from "lib/apolloClient/client";
import { courseFlowResourceFragment } from "./CourseFlowFragments";
import {
  getEntireCourseFlowFeedQuery,
  getUnitPlanDetailsQuery,
} from "./CourseFlowQueries";

export const getCourseFlowItemFromCache = ({ id, variables }) => {
  let fragmentData = {};
  try {
    fragmentData = cache.readFragment({
      id: `LearningCourseFlow:${id}`,
      fragment: courseFlowResourceFragment.completeDetails,
      fragmentName: "courseFlowResource",
      variables,
    });
  } catch (e) {
    return {};
  }
  return fragmentData;
};

export const writeCourseFlowItemInCache = ({ id, variables, data }) => {
  cache.writeFragment({
    id: `LearningCourseFlow:${id}`,
    fragment: courseFlowResourceFragment.completeDetails,
    fragmentName: "courseFlowResource",
    variables,
    data,
  });
};

export const getEntireCourseFlowFeedQueryFromCache = variables => {
  return cache.readQuery({
    query: getEntireCourseFlowFeedQuery,
    variables,
  });
};

export const getUnitPlanDetailsFromCache = ({ id, responseFilter }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getUnitPlanDetailsQuery,
      variables: {
        id,
        responseFilter,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};
